import { Dropdown, DropdownItem, LuneThemeNew } from '@lune-fe/lune-ui-lib'
import { EmissionEstimationIcons } from 'lune-components-lib/src/components'
import { DropdownSubmenuItem } from 'lune-ui-lib/src/components/Dropdown'
import { FC } from 'react'

import { transportModeToGroupMapping } from 'views/CalculateEmissions/RFQ/components/TransportModeGroupSelect'
import { groupIconMap } from 'views/CalculateEmissions/RFQ/components/TransportModeParameters'
import { TransportModeGroup } from 'views/CalculateEmissions/RFQ/utils/sharedLogic'
import { DisplayProperty, TRANSPORT_MODE_LABEL } from 'views/CalculateEmissions/RFQ/utils/types'
import { labelsMap } from 'views/CalculateEmissions/RFQ/utils/utils'

const { palette, spacing } = LuneThemeNew

const AdditionalPropertiesSelector: FC<{
    options: DisplayProperty[]
    onSelection: (selection: DisplayProperty) => void
}> = ({ options, onSelection }) => {
    if (!options.length) {
        return null
    }

    function getGroupProperties(group: TransportModeGroup): DisplayProperty[] {
        return options.filter((o) =>
            o.type === 'group'
                ? o.group === group
                : transportModeToGroupMapping[o.transportMode] === group,
        )
    }

    const orderedGroups: TransportModeGroup[] = ['Sea', 'Air', 'Road', 'Rail', 'Inland waterways']
    const groupedOptions: [TransportModeGroup, DisplayProperty[]][] = []
    for (const group of orderedGroups) {
        const properties = getGroupProperties(group)
        if (properties.length === 0) {
            continue
        }

        groupedOptions.push([group, properties])
    }

    function generateGroupProperties(properties: DisplayProperty[], hideTransportMode: boolean) {
        return properties.map((option) => {
            const propertyLabel = labelsMap[option.parameter]
            const label =
                option.type === 'transportMode'
                    ? `${propertyLabel}${hideTransportMode ? '' : ` (${TRANSPORT_MODE_LABEL[option.transportMode] ?? option.transportMode})`}`
                    : `${propertyLabel}`
            return (
                <DropdownItem
                    key={`${option.type === 'group' ? option.group : option.transportMode}::${option.parameter}`}
                    sx={{
                        padding: `0 ${spacing(3)}`,
                        height: '48px',
                        width: '280px',
                    }}
                    onClick={() => onSelection(option)}
                >
                    {label}
                </DropdownItem>
            )
        })
    }

    return (
        <Dropdown
            buttonLabel="Additional properties"
            typographyVariant="button"
            sx={{
                backgroundColor: 'transparent',
                height: '48px',
                width: 'fit-content',
                minWidth: '64px',
                padding: '0 12px',
                border: '2px solid !important',
                borderColor: `${palette.Grey900}`,
                color: `${palette.Grey900}`,
                borderRadius: '40px',
                boxShadow: 'none',
                outline: 'black',
                whiteSpace: 'nowrap',
            }}
            menuPadding="0"
        >
            {groupedOptions.length === 1
                ? groupedOptions.map(([_, properties]) => generateGroupProperties(properties, true))
                : groupedOptions.map(([group, properties]) => {
                      return (
                          <DropdownSubmenuItem
                              key={`submenu-${group}`}
                              label={group}
                              itemSx={{ padding: '16px' }}
                              leftIcon={EmissionEstimationIcons[groupIconMap[group]]}
                              iconSx={{ color: 'black' }}
                          >
                              {generateGroupProperties(properties, false)}
                          </DropdownSubmenuItem>
                      )
                  })}
        </Dropdown>
    )
}

export default AdditionalPropertiesSelector
